module.exports = __webpack_public_path__ + "static/publisher_blob-0f3828838e6395141c51d7bfec146738.svg";